import { createAction, createStoreAction } from '@cobuildlab/react-simple-state';
import {
  cancelSubscriptionToAdminEvent,
  cancelSubscriptionToAdminEventError,
  createUserInvitationDialogStore,
  fetchGlobalExtraUserEvent,
  fetchGlobalExtraUserEventError,
  fetchGlobalRegisterUsersErrorEvent,
  fetchGlobalRegisterUsersEvent,
  fetchGlobalUserEvent,
  fetchGlobalUserEventError,
  fetchUserByMonthsErrorEvents,
  fetchUserByMonthsEvents,
  fetchUserByProviderErrorEvents,
  fetchUserByProviderEvents,
  fetchUserCountErrorEvent,
  fetchUserCountEvent,
  updateGlobalUserEvent,
  updateGlobalUserEventError,
  updateGlobalUserExtraEvent,
  updateGlobalUserExtraEventError,
} from './user-events';
import axios from 'axios';
import { GlobalUserExtraData, GlobalUserJoinSocialProvider, UserDetailsFormType, UserExtraDetailsFormType } from './user-types';

import { BACKEND_ENDPOINT, DateFilter } from '../../shared/constants';
import { ProviderCountData } from '../dashboard/dashboard-types';

export const fetchUserByProviders = async (data: {
  from: string;
  to: string;
}): Promise<ProviderCountData[]> => {
  const { to, from } = data;
  const response = await axios.get<ProviderCountData[]>(
    `${BACKEND_ENDPOINT}/api/user/provider-count`,
    {
      params: {
        to,
        from,
      },
    },
  );

  return response.data;
};

export const fetchUserByMonth = createAction(
  fetchUserByMonthsEvents,
  fetchUserByMonthsErrorEvents,
  async (data: { from: string; to: string; filter: DateFilter }) => {
    const { from, to, filter } = data;
    const response = await axios.get<{ count: number; date: string }[]>(
      `${BACKEND_ENDPOINT}/api/user/count-by-date`,
      {
        params: {
          to,
          from,
          filter,
        },
      },
    );

    return response.data;
  },
);

export const fetchUserByProviderMetrics = createAction(
  fetchUserByProviderEvents,
  fetchUserByProviderErrorEvents,
  fetchUserByProviders,
);

export const fetchGlobalRegisterUsers = createAction(
  fetchGlobalRegisterUsersEvent,
  fetchGlobalRegisterUsersErrorEvent,
  async (data: { from: string; to: string; page: number; pageSize: number }) => {
    const { to, from, page, pageSize } = data;

    const response = await axios.get<{
      data: GlobalUserJoinSocialProvider[];
      total: number;
    }>(`${BACKEND_ENDPOINT}/api/user/all-by-filters`, {
      timeout: 60000,
      params: {
        to,
        from,
        page,
        pageSize,
      },
    });

    return response.data;
  },
);

// export const updateUserAction = createAction(
//   updateUserEvent,
//   updateUserErrorEvent,
//   async (variables: UpdateUserMutationVariables) => {
//     const response = await clientUpload.mutate<
//       UpdateUserMutation,
//       UpdateUserMutationVariables
//     >({
//       mutation: UpdateUserDocument,
//       variables,
//     });
//
//     return {
//       user: response.data?.updateUser as User,
//     };
//   },
// );

export const createUserInvitationDialogStoreAction = createStoreAction(
  createUserInvitationDialogStore,
  (prev, isOpen: boolean) => ({
    ...prev,
    isOpen,
  }),
);
export const fetchUserCount = createAction(
  fetchUserCountEvent,
  fetchUserCountErrorEvent,
  async () => {
    const response = await axios.get<{ count: number }>(`${BACKEND_ENDPOINT}/api/user/count`);
    return {
      count: response.data.count,
    };
  },
);

export const fetchGlobalUserAction = createAction(
  fetchGlobalUserEvent,
  fetchGlobalUserEventError,
  async (data: { id: string }) => {
    const { id } = data;
    const response = await axios.get<GlobalUserJoinSocialProvider>(
      `${BACKEND_ENDPOINT}/api/user/${id}`,
      {
        timeout: 60000,
      },
    );

    return response.data;
  },
);

export const updateGlobalUser = createAction(
  updateGlobalUserEvent,
  updateGlobalUserEventError,
  async (data: { userId: string | number; user: UserDetailsFormType; file: File | null }) => {
    const { user, userId, file } = data;

    const form = new FormData();
    form.append('user', JSON.stringify({ ...user, id: userId }));

    if (file) {
      form.append('file', file);
    }

    const url = `${BACKEND_ENDPOINT}/api/user/update`;

    try {
      await axios({
        method: 'post',
        url,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000,
      });
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }

      throw new Error('Error al actualizar el usuario');
    }
  },
);

export const cancelSubscriptionToAdmin = createAction(
  cancelSubscriptionToAdminEvent,
  cancelSubscriptionToAdminEventError,
  async (data: { subscriptionId: number; reason: string }) => {
    const response = await axios.get(
      `${BACKEND_ENDPOINT}/api/user/subscription/admin-cancel-subscription`,
      {
        timeout: 60000,
        params: data,
      },
    );

    return response.data;
  },
);

export const fetchGlobalExtraUserAction = createAction(
  fetchGlobalExtraUserEvent,
  fetchGlobalExtraUserEventError,
  async (data: { id: string }) => {
    const { id } = data;
    const response = await axios.get<GlobalUserExtraData>(
      `${BACKEND_ENDPOINT}/api/user/extra/${id}`,
      {
        timeout: 60000,
      },
    );

    return response.data;
  },
);

export const updateGlobalUserExtra = createAction(
  updateGlobalUserExtraEvent,
  updateGlobalUserExtraEventError,
  async (data: { userId: string | number; user: UserExtraDetailsFormType; file: File | null }) => {
    const { user, userId, file } = data;

    const form = new FormData();
    form.append('user', JSON.stringify({ ...user, id: userId }));

    if (file) {
      form.append('file', file);
    }

    const url = `${BACKEND_ENDPOINT}/api/user-extra/update`;

    try {
      await axios({
        method: 'post',
        url,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000,
      });
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }

      throw new Error('Error al actualizar el usuario');
    }
  },
);
